import { useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useKnowledgeBase() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const scrapeUrl = useCallback(async (url: string): Promise<{ title: string; content: string } | null> => {
    try {
      setLoading(true);
      setError(null);

      console.log(`Scraping URL: ${url}`);

      const { data, error } = await supabase.functions.invoke('scrape-url', {
        body: { url }
      });

      if (error) {
        console.error('Scraping error from function:', error);
        throw new Error(error.message || 'Failed to scrape URL');
      }

      if (!data) {
        console.error('No data returned from scraper');
        throw new Error('No data returned from scraper');
      }

      console.log(`Scraped data: title length=${data.title?.length || 0}, content length=${data.content?.length || 0}`);

      if (!data.content || data.content.trim() === '') {
        throw new Error('No content could be extracted from the URL');
      }

      return data;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An error occurred while scraping the URL';
      setError(errorMessage);
      console.error('Error scraping URL:', err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    scrapeUrl,
    loading,
    error,
    clearError: () => setError(null)
  };
}